<template>
  <div>
    <div class="page-content">
      <div class="container-fluid">
        <div class="card">
          <div class="card-head">上传配置</div>
          <div class="card-body">
            <Tabs type="card" :animated="false">
              <TabPane label="基础配置">
                <Form :model="basic" :label-width="100">
                  <FormItem label="上传类型">
                    
                    <RadioGroup v-model="basic.img_location">
                      <Radio label="location">本地存储</Radio>
                      <Radio label="aliyuncs">阿里云存储</Radio>
                      <Radio label="tencent">腾讯云存储</Radio>
                      <Radio label="qiniu">七牛云存储</Radio>
                    </RadioGroup>
                  </FormItem>

                  <FormItem>
                    <Button type="primary" @click="Save(basic)" :loading="creating">保存</Button>
                  </FormItem>
                </Form>
              </TabPane>
              <TabPane label="阿里云配置">
                <Form :model="aliyuncs" :label-width="120">
                  <FormItem label="空间域名">
                    <Input
                      v-model="aliyuncs.ali_url"
                      placeholder="空间域名 Domain"
                    ></Input>
                  </FormItem>
                  <FormItem label="AccessKey ID">
                    <Input
                      v-model="aliyuncs.ali_KeyId"
                      placeholder="AccessKey ID"
                    ></Input>
                  </FormItem>
                  <FormItem label="AccessKey Secret">
                    <Input
                      v-model="aliyuncs.ali_KeySecret"
                      placeholder="AccessKey Secret"
                    ></Input>
                  </FormItem>
                  <FormItem label="所属地域">
                    <Input
                      v-model="aliyuncs.ali_endpoint"
                      placeholder="所属地域 Endpoint"
                    ></Input>
                  </FormItem>
                  <FormItem label="空间名称">
                    <Input
                      v-model="aliyuncs.ali_bucket"
                      placeholder="空间名称 Bucket"
                    ></Input>
                  </FormItem>

                  <FormItem>
                    <Button type="primary" @click="Save(aliyuncs)" :loading="creating">保存</Button>
                  </FormItem>
                </Form>
              </TabPane>
              <TabPane label="腾讯云配置">
                <Form :model="tencent" :label-width="100">
                  <FormItem label="空间域名">
                    <Input
                      v-model="tencent.tencent_url"
                      placeholder="空间域名 Domain"
                    ></Input>
                  </FormItem>
                  <FormItem label="secretId">
                    <Input
                      v-model="tencent.tencent_secretId"
                      placeholder="secretId"
                    ></Input>
                  </FormItem>
                  <FormItem label="secretKey">
                    <Input
                      v-model="tencent.tencent_secretKey"
                      placeholder="secretKey"
                    ></Input>
                  </FormItem>
                  <FormItem label="所属地域">
                    <Input
                      v-model="tencent.tencent_region"
                      placeholder="所属地域 Region"
                    ></Input>
                  </FormItem>
                  <FormItem label="空间名称">
                    <Input
                      v-model="tencent.tencent_bucket"
                      placeholder="空间名称 Bucket"
                    ></Input>
                  </FormItem>

                  <FormItem>
                    <Button type="primary" @click="Save(tencent)" :loading="creating">保存</Button>
                  </FormItem>
                </Form>
              </TabPane>
              <TabPane label="七牛云配置">
                <Form :model="qiniu" :label-width="100">
                  <FormItem label="空间域名">
                    <Input
                      v-model="qiniu.qiniu_url"
                      placeholder="空间域名 Domain"
                    ></Input>
                  </FormItem>
                  <FormItem label="AccessKey">
                    <Input
                      v-model="qiniu.qiniu_AccessKey"
                      placeholder="AccessKey"
                    ></Input>
                  </FormItem>
                  <FormItem label="SecretKey">
                    <Input
                      v-model="qiniu.qiniu_SecretKey"
                      placeholder="SecretKey"
                    ></Input>
                  </FormItem>
                  
                  <FormItem label="空间名称">
                    <Input
                      v-model="qiniu.qiniu_bucket"
                      placeholder="空间名称 Bucket"
                    ></Input>
                  </FormItem>

                  <FormItem>
                    <Button type="primary" @click="Save(qiniu)" :loading="creating">保存</Button>
                  </FormItem>
                </Form>
              </TabPane>
            </Tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSystem, putSystem } from "@/api/admin";
export default {
  data() {
    return {
      basic: {
        img_location: "",
      },
      aliyuncs:{},
      tencent:{},
      qiniu:{},
      creating:false
    };
  },
  created() {
    this._getData();
  },

  methods: {
    // 获取列表
    _getData() {
      getSystem("basic").then((res) => {
        this.basic.img_location = res.data.img_location;
      });
      getSystem("aliyuncs").then((res) => {
        this.aliyuncs = res.data;
      });
      getSystem("tencent").then((res) => {
        this.tencent = res.data;
      });
      getSystem("qiniu").then((res) => {
        this.qiniu = res.data;
      });
    },
    // 基础配置
    Save(arr) {
      this.creating = true
      putSystem({
        createData: arr,
      }).then((res) => {
        if (res.code == 200) {
          this.$Message.success({
            background: true,
            content: res.msg,
          });
          this._getData();
        } else {
          this.$Message.error({
            background: true,
            content: res.msg,
          });
        }
        this.creating = false
      });
    },
  },
};
</script>

<style lang="less" scoped>
.card-body {
  height: 435px;
}
.ivu-radio-wrapper{
  margin-right: 20px;
}
</style>